import { render } from "./Transaksi.vue?vue&type=template&id=6c422147&scoped=true"
import script from "./Transaksi.vue?vue&type=script&lang=js"
export * from "./Transaksi.vue?vue&type=script&lang=js"

import "./Transaksi.vue?vue&type=style&index=0&id=6c422147&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c422147"]])

export default __exports__